import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import backgroundElement from '../../../assets/img/mobileLanding/background-ele.png';

interface BackgroundElementProps {
    /**
     * Custom sx styles to position and style the background element
     */
    sx?: SxProps<Theme>;
    /**
     * Alt text for the image
     */
    alt?: string;
}

/**
 * Reusable background decorative element component
 * Used across mobile landing sections for consistent visual styling
 */
function BackgroundElement({ sx, alt = "Background Element" }: BackgroundElementProps) {
    return (
        <Box
            component="img"
            src={backgroundElement}
            alt={alt}
            sx={{
                position: 'absolute',
                ...sx,
            }}
        />
    );
}

export default BackgroundElement;
